import { useSocket, useUnseenCount } from '@novu/notification-center'
import { useEffect } from 'react'
import { toast } from 'react-toastify'
import ContentNotification from './ContentNotification'
import config from '../../config'

export const RealtimeNotificationAlert = () => {
  const { socket } = useSocket()
  const { data: unseenCount } = useUnseenCount()
  useEffect(() => {
    if (socket && unseenCount) {
      socket.on('notification_received', (data) => {
        if (unseenCount.count + 1 <= config.MAX_NOTIFICATIONS_TO_DISPLAY) {
          toast(<ContentNotification content={data.message.content} />, {
            type: 'info',
          })
        } else {
          toast.dismiss()
          toast(
            <ContentNotification
              content={`Vous avez plus de ${
                unseenCount.count + 1
              } nouvelles notifications`}
            />,
            {
              type: 'info',
            }
          )
        }
      })
    }
    return () => {
      if (socket) {
        socket.off('notification_received')
      }
    }
  }, [socket, unseenCount])

  return <></>
}

export default RealtimeNotificationAlert
